import { ErrorBoundary as FoundationErrorBoundary, foundationErrorBoundaryTemplate as template, } from '@genesislcap/foundation-ui';
export const zeroErrorBoundaryShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
/**
 * @deprecated
 * @tagname %%prefix%%-error-boundary
 */
export class ErrorBoundary extends FoundationErrorBoundary {
}
export const zeroErrorBoundary = ErrorBoundary.compose({
    baseName: 'error-boundary',
    template,
    shadowOptions: zeroErrorBoundaryShadowOptions,
});
